import React, { createContext, useContext, useState, useCallback } from 'react';

const TestModeContext = createContext(null);

const STORAGE_KEY = 'trustgate-test-mode';

export function TestModeProvider({ children }) {
  const [isTestMode, setIsTestMode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  const toggleTestMode = useCallback(() => {
    setIsTestMode((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, String(next));
      } catch {
        // localStorage unavailable
      }
      return next;
    });
  }, []);

  const setTestMode = useCallback((value) => {
    setIsTestMode(value);
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // localStorage unavailable
    }
  }, []);

  return (
    <TestModeContext.Provider value={{ isTestMode, toggleTestMode, setTestMode }}>
      {children}
    </TestModeContext.Provider>
  );
}

export function useTestMode() {
  const context = useContext(TestModeContext);
  if (!context) {
    throw new Error('useTestMode must be used within a TestModeProvider');
  }
  return context;
}
